import { render, staticRenderFns } from "./OrgUsersTeams.vue?vue&type=template&id=43940dc2&scoped=true&"
import script from "./OrgUsersTeams.vue?vue&type=script&lang=js&"
export * from "./OrgUsersTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43940dc2",
  null
  
)

export default component.exports